import React from 'react';
import { Icon, InlineIcon } from '@iconify/react';
import codeforcesIcon from '@iconify-icons/simple-icons/codeforces';

const Footer = () => {
   return (
      <footer id="footer">
         <div className="footer__container">
            <div className="footer__content">
               <div className="footer__icons">
                  <span><a href="https://www.linkedin.com/in/parth-jain-7148061bb/" target="_blank"><i className="fab fa-linkedin-in fa-lg"></i></a></span>
                  <span><a href="mailto:parthljain2002@gmail.com"><i className="fas fa-envelope fa-lg"></i></a></span>
                  <span><a href="https://codeforces.com/profile/parthljain2002"><Icon icon={codeforcesIcon} /></a></span>
                  <span><a href="https://github.com/Parth-Jain-2002" target="_blank"><i className="fab fa-github fa-lg"></i></a></span>
                  <span><a href="https://www.youtube.com/channel/UC9xs7QRapRZZ2XaK1iFJCyQ" target="_blank"><i class="fab fa-youtube"></i></a></span>
                  <span><a href="https://www.instagram.com/parthjain2002/" target="_blank"><i className="fab fa-instagram fa-lg"></i></a></span>
               </div>
            </div>
         </div>
      </footer>
   )
}

export default Footer
